import { create } from 'zustand';

type Store = {
  isChangeActionsBlock: boolean;
  isRequestFetching: boolean;
  pointerBlockedStyles: string;
  scenarioId: string;
  search: string;
  setActionStateBlocked: (state: boolean) => void;
  setRequestState: (state: boolean) => void;
  setScenarioId: (id: string) => void;
  setSearch: (query: string) => void;
  setSharePrice: (sharePrice: number) => void;
  sharePrice: number;
};
const POINTER_BLOCKED_STYLES =
  'relative before:content-[""] before:absolute before:inset-0 before:z-50 before:pointer-events-auto before:cursor-progress';

export const useScenarioStore = create<Store>()((set) => {
  return {
    isChangeActionsBlock: false,
    scenarioId: '',
    search: '',
    sharePrice: 0,
    pointerBlockedStyles: '',
    isRequestFetching: false,
    setSearch(query) {
      set(() => {
        return { search: query };
      });
    },
    setScenarioId: (id) =>
      set(() => {
        return { scenarioId: id };
      }),

    setRequestState: (state) =>
      set(() => {
        return { isRequestFetching: state };
      }),

    setActionStateBlocked: (boolean) =>
      set(() => {
        return {
          isChangeActionsBlock: boolean,
          pointerBlockedStyles: boolean ? POINTER_BLOCKED_STYLES : '',
        };
      }),
    setSharePrice: (sharePrice) =>
      set(() => {
        return { sharePrice };
      }),
  };
});
